export const COURSE_COLORS = {
  blue: { bg: "bg-blue-50", text: "text-blue-700", border: "border-blue-200", dot: "bg-blue-500", ring: "#3b82f6" },
  emerald: { bg: "bg-emerald-50", text: "text-emerald-700", border: "border-emerald-200", dot: "bg-emerald-500", ring: "#10b981" },
  amber: { bg: "bg-amber-50", text: "text-amber-700", border: "border-amber-200", dot: "bg-amber-500", ring: "#f59e0b" },
  indigo: { bg: "bg-indigo-50", text: "text-indigo-700", border: "border-indigo-200", dot: "bg-indigo-500", ring: "#6366f1" },
  rose: { bg: "bg-rose-50", text: "text-rose-700", border: "border-rose-200", dot: "bg-rose-500", ring: "#f43f5e" },
  teal: { bg: "bg-teal-50", text: "text-teal-700", border: "border-teal-200", dot: "bg-teal-500", ring: "#14b8a6" },
};
export const COLOR_KEYS = Object.keys(COURSE_COLORS);
export const colorOf = (c) => COURSE_COLORS[c] || COURSE_COLORS.blue;

export const EVENT_TYPES = [
  "assignment", "homework", "project", "essay", "exam", "midterm",
  "final", "quiz", "presentation", "lab", "reading", "discussion", "event",
];

export const STATUSES = [
  { key: "not_started", label: "Not started" },
  { key: "in_progress", label: "In progress" },
  { key: "completed", label: "Completed" },
];

export function fmtDate(dateStr) {
  if (!dateStr) return "Date TBD";
  const d = new Date(dateStr + (dateStr.length === 10 ? "T00:00:00" : ""));
  if (isNaN(d)) return "Date TBD";
  return d.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });
}

export function daysUntil(dateStr) {
  if (!dateStr) return null;
  const d = new Date(dateStr + "T00:00:00");
  if (isNaN(d)) return null;
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  return Math.round((d - now) / 86400000);
}

export function urgency(dateStr, status) {
  if (status === "completed") return { color: "text-emerald-600", dot: "bg-emerald-500", label: "Done" };
  const n = daysUntil(dateStr);
  if (n === null) return { color: "text-slate-400", dot: "bg-slate-300", label: "TBD" };
  if (n < 0) return { color: "text-red-600", dot: "bg-red-500", label: `${Math.abs(n)}d overdue` };
  if (n <= 3) return { color: "text-red-600", dot: "bg-red-500", label: `${n}d` };
  if (n <= 7) return { color: "text-amber-600", dot: "bg-amber-500", label: `${n}d` };
  return { color: "text-slate-500", dot: "bg-slate-300", label: `${n}d` };
}
